module.exports = __webpack_public_path__ + "assets/img/56@3x.7508e4bb.png";